import { Banner } from '@shopify/polaris';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Action } from '@shopify/polaris';
import IfCondition from 'components/shared/If-condition';
import { useIntercom } from 'react-use-intercom';
import { GlobalBannerError } from '../model/error-banner';

interface ErrorBannerProps {
    banner: GlobalBannerError;
    onDismiss?: () => void;
    children?: React.ReactNode;
}

const ErrorBanner: React.FC<ErrorBannerProps> = ({ banner, onDismiss, children }) => {
    const { t } = useTranslation('translation');

    const intercom = useIntercom();

    const addSupportAction = (): Action => {
        return {
            content: t('GENERAL_ERROR_BANNER.CONTACT_SUPPORT'),
            onAction: () => intercom.showNewMessage(banner.contentToIntercom),
        };
    };

    const getContent = () => {
        if (children) {
            return <>{children}</>;
        }
        if (banner.descriptionKey || banner.errorContent) {
            return (
                <>
                    <IfCondition condition={!!banner.descriptionKey}>
                        <div
                            dangerouslySetInnerHTML={{
                                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                __html: t(banner.descriptionKey as any, {
                                    ...(!!banner.descriptionInterpolation && { ...banner.descriptionInterpolation }),
                                }),
                            }}
                        ></div>
                    </IfCondition>
                    <IfCondition condition={!!banner.errorContent}>
                        <div> {banner.errorContent}</div>
                    </IfCondition>
                </>
            );
        }
    };

    if (banner) {
        return (
            <Banner
                tone={banner.tone}
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                title={banner.withDefaultTitle ? t('GENERAL_ERROR_BANNER.TITLE') : t(banner.titleKey as any)}
                action={banner.withSupportActions ? addSupportAction() : banner.action}
                secondaryAction={banner.secondaryAction}
                onDismiss={banner.hideDismissButton ? () => {} : onDismiss}
            >
                {getContent()}
            </Banner>
        );
    }
};

export default ErrorBanner;
